import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { fetchFilterForCrossCampaignCategory } from '@browsing/filters';
import { getCategoryFilters } from '@client/redux/modules/filters';

export const useAllCategories = () => {
    const categories = useSelector(getCategoryFilters);
    const [allCategories, setAllCategories] = useState(categories);

    useEffect(() => {
        const fetchFilterCategories = async () => {
            try {
                if (!allCategories?.categories?.length) {
                    const { categoryFilter } = await fetchFilterForCrossCampaignCategory();
                    setAllCategories(categoryFilter);
                }
            } catch (e) {
                console.log(e);
            }
        };
        fetchFilterCategories();
    }, []);

    return allCategories;
};
